export { type CubicBezier, type ReadonlyCubicBezier } from './types.ts';

export {
  createCubicBezier,
  transformCubicBezier,
  createCubicBezierFromValues,
  getPointOnCubicBezier,
  getTangentOnCubicBezier,
  walkPointsAlongCubicBezier,
  getCubicBezierLength,
  getClosestPointAlongCubicBezier,
  isPointWithinDistanceOfCubicBezier,
  getCubicBezierBoundingBox,
  boxIntersectsCubicBezier,
  intersectionPointsOfLineAndBezier,
  approximateCubicBezierBoundingBox,
  type IntersectionPointOfLineAndBezierResult,
} from './bezier.ts';

export {
  createSmoothCubicBezierSplineFromPoints,
  SplineMode,
} from './create-smooth-cubic-bezier-spline-from-points.ts';
